import React, { useCallback, useEffect } from 'react'
import PropTypes from 'prop-types'

import { Mail } from '@/components/Icons'
import { Badge, CircularProgress, Fab, Tooltip } from '@material-ui/core'
import { batchInvitations, getPendingInvitationsCount } from '@/api/admin'
import { toast } from 'react-toastify'

export function BatchInvitationsButton({ onSuccess }) {
  const [isLoading, setIsLoading] = React.useState(false)

  const [pendingInvitationsCount, setPendingInvitationsCount] =
    React.useState(0)

  const handleGetPendingInvitationsCount = useCallback(async () => {
    const count = await getPendingInvitationsCount()

    setPendingInvitationsCount(count)
  }, [])

  async function handleBatchInvitations() {
    setIsLoading(true)

    const completed = await batchInvitations()

    if (completed) {
      toast.success('Convites enviados')
      onSuccess()

      handleGetPendingInvitationsCount()
    }

    setIsLoading(false)
  }

  useEffect(() => {
    handleGetPendingInvitationsCount()
  }, [handleGetPendingInvitationsCount])

  if (pendingInvitationsCount === 0) return null

  return (
    <Tooltip title="Enviar convites">
      <Fab
        disabled={isLoading}
        onClick={handleBatchInvitations}
        color="primary"
      >
        <Badge color="error" badgeContent={pendingInvitationsCount} max={99}>
          {isLoading ? <CircularProgress color="secondary" /> : <Mail />}
        </Badge>
      </Fab>
    </Tooltip>
  )
}

BatchInvitationsButton.propTypes = {
  onSuccess: PropTypes.func.isRequired,
}
